import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { InputTextarea } from "primereact/inputtextarea";
import { Tooltip } from "primereact/tooltip";
import { Button } from "primereact/button";
import classNames from "classnames";
import SpamSuggestions from "./spam-suggestions";
import { Text } from "../../../components/Text";
import "./stylles.css";
import { CustomButton } from "../../../components/CustomButton";

const N8N_WEBHOOK_URL = process.env.REACT_APP_N8N_WEBHOOK_URL;
const TEMPLATE_DOC_URL = process.env.REACT_APP_TEMPLATE_DOC_URL;

const TemplateBodyField = ({
  control,
  textAreaRef,
  getFormErrorMessage = () => {},
  SPAM_SUGGESTIONS,
  showSpamSuggestions,
  setShowSpamSuggestions,
  checkForSpam,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [showTypingIndicator, setShowTypingIndicator] = useState(false);

  return (
    <div className="w-full relative">
      <label htmlFor="content" className="inline-block mb-2">
        Body *
      </label>

      <Controller
        name="content"
        control={control}
        spellCheck={true}
        rules={{ required: "Content is required." }}
        render={({ field, fieldState }) => {
          const spamMatches = checkForSpam(field.value || "");

          const handleGenerateWithAI = async () => {
            const prompt = field.value;
            if (!prompt) {
              setApiError("Please enter a prompt to generate content.");
              return;
            }

            setIsLoading(true);
            setApiError(null);
            setShowTypingIndicator(true);

            try {
              const response = await fetch(N8N_WEBHOOK_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  chatInput: prompt,
                  sessionId: "template-body-session",
                }),
              });

              if (!response.ok)
                throw new Error(`HTTP error! ${response.status}`);

              const data = await response.json();
              setShowTypingIndicator(false);

              const aiResponse =
                (data && data[0]?.output) ||
                data?.output ||
                "Sorry, I couldn't process that.";
              field.onChange(aiResponse);
            } catch (error) {
              console.error("Error calling n8n webhook:", error);
              setApiError("Failed to generate content. Please try again.");
              setShowTypingIndicator(false);
            } finally {
              setIsLoading(false);
            }
          };

          return (
            <div className="relative">
              <InputTextarea
                className={classNames(
                  {
                    "p-invalid": fieldState.invalid || spamMatches.length > 0,
                  },
                  "w-full"
                )}
                id={field.name}
                value={field.value}
                rows={3}
                cols={30}
                {...field}
                maxLength={1028}
                placeholder="Enter your content or a prompt to generate "
                ref={textAreaRef}
                disabled={isLoading}
              />

              {showTypingIndicator && (
                <div className="typing-indicator mt-2">
                  <Text size="small" color="text-secondary">
                    AI is typing
                    <span className="typing-dots"></span>
                  </Text>
                </div>
              )}

              <div className="ai-button-wrapper">
                {/* <Button
                  label={isLoading ? "Generating..." : "Generate with AI"}
                  icon={isLoading ? "pi pi-spin pi-spinner" : "pi pi-robot"}
                  onClick={handleGenerateWithAI}
                  disabled={isLoading}
                  size="small"
                  outlined
                  className="p-button-help"
                  type="button"
                /> */}
                <CustomButton
                varient="filled"
                label={isLoading ? "Generating..." : "Generate with AI"}
                icon={isLoading ? "pi pi-spin pi-spinner" : "pi pi-robot"}
                onClick={handleGenerateWithAI}
                disabled={isLoading}
                className="w-full"                 
                />
              </div>

              {apiError && (
                <Text className="api-error" size="small">
                  {apiError}
                </Text>
              )}

              {spamMatches.length > 0 && (
                <SpamSuggestions
                  spamMatches={spamMatches}
                  showSuggestions={showSpamSuggestions}
                  setShowSuggestions={setShowSpamSuggestions}
                  fieldValue={field.value}
                  SPAM_SUGGESTIONS={SPAM_SUGGESTIONS}
                  onReplace={(word) => {
                    const updated = field.value.replace(
                      new RegExp(word, "gi"),
                      SPAM_SUGGESTIONS[word] || ""
                    );
                    field.onChange(updated);
                  }}
                />
              )}
              {getFormErrorMessage("content")}

              <div className="info-box">
                <i
                  className="pi pi-info-circle cursor-pointer open-doc-icon text-lg"
                  data-pr-tooltip="Click to view template documentation"
                  data-pr-position="top"
                  onClick={() => window.open(TEMPLATE_DOC_URL, "_blank")}
                  color="text-gray-600"
                />
                <small>
                  The text limit in the body should be less than 550 characters
                  and emojis should be less than 10 to avoid any template
                  rejection.
                </small>
              </div>
            </div>
          );
        }}
      />

      <Tooltip target=".open-doc-icon" />
    </div>
  );
};

export default TemplateBodyField;
